import React from 'react'
import { Merchant } from '@slerp/controls'
import { StripeConnect } from '../Utils/Stripe'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'

const StripeConnectSettings = (props: { merchant: Merchant }) => {
  const { stripeConnectData } = useMerchant()
  const { merchant } = props

  return (
    <StripeConnect
      stripeId={merchant?.stripe_settings?.[0]?.stripe_user_id}
      hasStripeCustomerId={!!merchant?.subscription?.stripe_customer_id}
      stripeConnectUrl={stripeConnectData}
    />
  )
}

export default StripeConnectSettings
